import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';

/** Replace with the live checkout URL. */
const CHECKOUT_URL = 'https://megapack-cheer-coach-pro.impultienda.ar/checkout';
const included = ['6 complete volumes', '5 instant-use bonuses', '300+ pages, print-ready', 'Stunt levels 1–6', 'All team types and season phases', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-ice text-ink" data-id="element-136" data-mp="1rsq1me6jcskp">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-137" data-mp="25shnf13and99">
        <div className="text-center" data-id="element-138" data-mp="25pv5q8movhdb">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-139" data-mp="20sv7ukzztkxa">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-140" data-mp="3h5tlevcdh1ni">
            Everything you need for the rest of this season
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-ice-dark bg-white shadow-card" data-id="element-141" data-mp="4svulmgz8wra">
          <div className="bg-navy px-5 py-5 text-center" data-id="element-142" data-mp="9si8zz8jkj1o">
            <h3 className="font-display text-xl uppercase tracking-wide text-white sm:text-2xl" data-id="element-143" data-mp="9t0b3chvxrhi">
              Cheer Coach Pro — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-bold text-gold-hover" data-id="element-144" data-mp="3d9qq2gvg3evc">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-145" data-mp="3i8bs8lu9c8mf">
            <img src="https://cdn.magicpatterns.com/uploads/hiSNvZtmrkg7LvEyCiMU5M/hf_20260917_195831_857e49cb-d5cd-44ff-a2f7-c7381e31565f_(1).png" alt="Cheer Coach Pro complete package: six spiral-bound volumes with the system on desktop, tablet and phone" width={1200} height={886} loading="lazy" className="mx-auto w-full max-w-lg" data-id="element-146" data-mp="3n6lkooolkv4c" />

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-147" data-mp="2rfjwhfc5mqn5">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-148" data-mp="2mh8o791ico71">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-149" data-mp="316xufiogjie6">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-150" data-mp="2w83846ra7bpb" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-ice-dark pt-6 text-center" data-id="element-151" data-mp="2igpt964bj20m">
              <p className="text-[13px] text-ink-soft" data-id="element-152" data-mp="2dh3eutcr7fq8">
                Total value{' '}
                <span className="text-ink-muted line-through" data-id="element-153" data-mp="2djg7q1k1vai2">$90 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-154" data-mp="3txg3d0bv4dzi">
                <span className="mt-2.5 font-display text-3xl" data-id="element-155" data-mp="3ovqplcx99m7q">$</span>
                <span className="font-display text-6xl leading-[0.9] sm:text-7xl" data-id="element-156" data-mp="a42rp0cwqnv">
                  27
                </span>
                <span className="mt-3 text-[13px] font-bold text-ink-muted" data-id="element-157" data-mp="5b1k5zdjlgob">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-158" data-mp="3rgot16il7uju">
                <span className="rounded border border-gold bg-gold px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-gold-ink" data-id="element-159" data-mp="3rirfjgkj75jt">
                  Save $63
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-160" data-mp="nz6i2q7iq7f7">
                  One-time payment
                </span>
                <span className="rounded border border-ice-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-161" data-mp="e8bzbvthdpyi">
                  Lifetime access
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-162" data-mp="16saicuf8riis">
                Get Cheer Coach Pro now — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-163" data-mp="3a85wjjqt6jjv">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-164" data-mp="359mbrmnybdt3">
                <li className="flex items-center gap-1.5" data-id="element-165" data-mp="319twkr41y9er">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-166" data-mp="1rato4a0gz5s" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-167" data-mp="3o75d04463s4y">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-168" data-mp="3k6lht635mylg" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-169" data-mp="fset8dtubdbq">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-170" data-mp="fqtyoo7izudv" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-171" data-mp="27fjvy3m9zdg8">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}